<template>
  <div v-if="campaign !== null">
    <InsightsHeader :campaign="campaign" />

    <vs-row>
      <div class="vx-col w-full">
        <InsightsContent :campaign="campaign" />
      </div>
    </vs-row>
  </div>
</template>
<script>
import InsightsContent from '@/views/campaigns/insights/components/InsightsContent.vue'
import InsightsHeader from '@/views/campaigns/insights/components/InsightsHeader.vue'

export default {
  components: {
    InsightsHeader,
    InsightsContent
  },
  data () {
    return {
      campaign: null
    }
  },
  async created () {
    try {

      const response = await window.axios.get(`/campaigns/${this.$route.params.id}/insights`)
      this.campaign = response.data.payload

    } catch (error) {
      alert('Error processing the request')
    }
  }
}
</script>
